(function() {
    document.addEventListener('DOMContentLoaded', function () {
        try {
            const addToCartButtons = document.querySelectorAll('.App_mainContainer__ale26 .Section_sectionWrapper__PcA7I .Section_sectionProducts__VSxEN .ProductItem_productAtc__0MOUU button');
            
            if (addToCartButtons.length === 0) {
                throw new Error('No Add to Cart buttons found on the page.');
            }
            function disableOtherButtons() {
                addToCartButtons.forEach(button => {
                    button.disabled = true; 
                });
            }
            function enableAllButtons() {
                addToCartButtons.forEach(button => {
                    button.disabled = false;
                });
            }
            addToCartButtons.forEach(button => {
                button.addEventListener('click', function () {
                    disableOtherButtons();
                    addToCartAndUpdateSidebar();
                    checkCartStatus();
                });
            });

            function addToCartAndUpdateSidebar() {
                fetch('/cart.js')  
                    .then(response => response.json())
                    .then(cart => {
                        if (cart.items.length > 0) {
                            const sidebarCart = document.querySelector('.Cart_sidebarCartProducts__4Juf4');

                            if (sidebarCart) {
                                sidebarCart.innerHTML = '';

                                cart.items.forEach(item => {
                                    const productDiv = document.createElement('div');
                                    productDiv.className = 'sidebar-product';
                                    productDiv.innerHTML = `
                                        <p>${item.title}</p>
                                        <p>Quantity: ${item.quantity}</p>
                                        <p>Price: $${item.price / 100}</p>
                                    `;

                                    sidebarCart.appendChild(productDiv);
                                });
                            } else {
                                console.error('Sidebar cart element not found.');
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching or updating cart:', error);
                    });
            }
            function checkCartStatus() {
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        if (cart.item_count === 0) {
                            enableAllButtons();
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching cart:', error);
                    });
            }

            checkCartStatus();
        } catch (error) {
            console.error('An error occurred:', error);
        }
    });
})();
